import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    consultaCEP(context, cep) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("servicosExternos/access/consultaCEP", { CEP: cep }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    consultaCidades(context, estado) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("servicosExternos/access/consultaCidades", { ESTADO: estado }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    consultaBairros(context, cidade) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("servicosExternos/access/consultaBairros", { CIDADE: cidade }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};